import { CollectionState } from "./BaseModel";
import { WorkCollectionMeta, WorkDTO } from "./dto/WorkDTO";

export interface WorkModel extends WorkDTO {
    /** Authoritative count of APPROVED applications, independent of pagination. */
    selectedExecutorsCount?: number
}

export interface WorksState
    extends CollectionState<WorkModel, WorkCollectionMeta> {
    savingWorkIds: string[];
    isSavedWorksCollection: boolean;
}

export const InitialWorks: WorksState = {
    rows: [],
    totalPages: 0,
    totalRows: 0,
    savingWorkIds: [],
    isSavedWorksCollection: false,
    meta: {
        applicationsCount: 0,
        completedWorksCount: 0,
        createdWorksCount: 0,
    },
};

export interface PromotionWorksState {
    interestingWorks: WorksState;
}

export const InitialPromotionWorks: PromotionWorksState = {
    interestingWorks: InitialWorks,
};

export enum WorkListType {
    COMMON = 1,
    INTERESTING_WORKS = 2,
}
